var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniLeisure01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.621094,
    y: 0.0527344,
    width: 258,
    height: 252,
    fill: "#D6895E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_503_15754",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.621094,
    y: 0.0527344,
    width: 258,
    height: 252,
    fill: "#D6895E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_503_15754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.289 242.053V222.256H190.055C194.553 222.256 197.137 225.031 197.137 228.928C197.137 232.879 194.512 235.6 189.945 235.6H186.391V242.053H182.289ZM186.391 232.291H189.289C191.723 232.291 192.912 230.924 192.898 228.928C192.912 226.959 191.723 225.633 189.289 225.619H186.391V232.291ZM201.102 242.299C199.816 242.299 198.777 241.273 198.805 240.002C198.777 238.744 199.816 237.719 201.102 237.732C202.318 237.719 203.371 238.744 203.371 240.002C203.371 241.273 202.318 242.299 201.102 242.299ZM206.707 242.053V222.256H214.473C218.971 222.256 221.555 225.031 221.555 228.928C221.555 232.879 218.93 235.6 214.363 235.6H210.809V242.053H206.707ZM210.809 232.291H213.707C216.141 232.291 217.33 230.924 217.316 228.928C217.33 226.959 216.141 225.633 213.707 225.619H210.809V232.291ZM228.117 222.256V242.053H224.07V222.256H228.117ZM237.988 242.354C233.436 242.34 230.646 239.4 230.66 234.697C230.646 230.117 233.477 227.014 237.824 227.014C241.721 227.014 244.797 229.475 244.797 234.533V235.682H234.652C234.652 237.924 235.979 239.305 238.07 239.318C239.451 239.305 240.436 238.703 240.832 237.814H244.688C244.113 240.562 241.652 242.34 237.988 242.354ZM234.652 233.139H240.969C240.955 231.334 239.711 230.035 237.906 230.049C236.047 230.035 234.734 231.43 234.652 233.139Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.99 34.9297C186.99 34.3774 187.438 33.9297 187.99 33.9297H194.098C194.65 33.9297 195.098 34.3774 195.098 34.9297V164.876H186.99V34.9297Z",
    fill: "#34328B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.045 37.4453L255.047 117.447C255.472 117.979 255.254 118.77 254.617 119.008L191.045 142.848V37.4453Z",
    fill: "#353071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.045 41.5L243.078 117.548C243.427 118.059 243.234 118.762 242.672 119.021L191.045 142.849V41.5Z",
    fill: "#8F87F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.99 53.6602L151.007 133.321C150.747 133.896 151.079 134.565 151.694 134.707L186.99 142.847V53.6602Z",
    fill: "#F0EFF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.99 53.6602L186.798 57.8015L182.923 141.061L186.99 142.847V53.6602Z",
    fill: "#ABA9C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.424 172.107C110.838 171.506 111.208 170.494 112.044 170.413L270.152 155.2C270.969 155.121 271.527 156.006 271.105 156.71L248.092 195.064C247.912 195.365 247.586 195.549 247.235 195.549H134.712C134.442 195.549 134.184 195.44 133.996 195.248L111.424 172.107Z",
    fill: "#4841A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.151 155.2L158.613 165.941C208.736 179.907 227.447 180.892 255.837 182.152L271.104 156.71C271.527 156.006 270.968 155.121 270.151 155.2Z",
    fill: "#353071"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLeisure01);
export default __webpack_public_path__ + "static/media/mini_leisure_01.111a438608abb180592c49dea59ca4fa.svg";
export { ForwardRef as ReactComponent };